import { Component, Input, SimpleChanges, ChangeDetectionStrategy, OnChanges, ChangeDetectorRef } from '@angular/core';

import { ApiService } from '@usimweb/core/services';
import { Helper } from '@usimweb/core/services';

@Component({
    selector: 'app-result-plot',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './result-plot.component.html',
    styleUrls: ['./result-plot.component.scss'],
    standalone: false
})
export class ResultPlotComponent implements OnChanges {
  @Input() id: string[] = [];

  @Input() titles: string[] = [];

  @Input() data: any = {};

  @Input() layout: any = {};

  public plotData: any[] = [];
  public plotLayout: any = { width: 600, height: 500, title: '' };
  public useResizeHandler = true;

  public plotTypes = [
    { key: 'filling', value: 'Filling' },
    { key: 'mass', value: 'Mass' },
    { key: 'density', value: 'Density' },
    { key: 'pressure', value: 'Pressure' },
    { key: 'temperature', value: 'Temperature' },
    { key: 'viscosity', value: 'Viscosity' },
  ];

  public plotType = this.plotTypes[0].key;
  public key = 'key';
  public value = 'value';
  public width = '20%';

  public projectOne: string = '';
  public projectTwo: string = '';

  constructor(private apiService: ApiService, private cd: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.data && changes['data']) {
      this.plotData = Helper.Array.deepCopy(this.data);
      this.plotLayout = Helper.Array.deepCopy(this.layout);

      this.setPlotSize();
    }

    if (changes['titles']) {
      this.projectOne = this.titles[0];
      this.projectTwo = this.titles[1];
    }
  }

  private setPlotSize() {
    this.plotLayout.height = 600;

    let width = screen.width * 0.4;

    if (screen.width < 1200) {
      width = screen.width * 0.9;
    }

    this.plotLayout.width = width;
    this.plotLayout.legend = {
      x: 0,
      y: 1.2,
    };
  }

  public selectedPlotType(event: string) {
    const subscription = this.apiService
      .getFoamingProjectCompareCurves(Helper.StringFormatter.concatStr(this.id), event || 'all')
      .subscribe((response) => {
        subscription.unsubscribe();
        this.plotData = response['data'];
        this.plotLayout = response['layout'];
        this.setPlotSize();
        this.cd.detectChanges();
      });
  }
}
